window.JordigiToolCatalog = [
 {
  "name": "Hoeveelheidscalculator",
  "description": "Laat bezoekers berekenen hoeveel materiaal zij nodig hebben.",
  "branch": "Bouw & interieur",
  "task": "Berekenen",
  "goal": "Materiaal bepalen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-145-1.webp",
  "options": [
   {
    "label": "Hoeveelheidscalculator",
    "id": 145,
    "price": 5.99,
    "url": "/pages/demo?view=oppervlakte-studio"
   }
  ],
  "presets": [
   {
    "label": "Parket op maat",
    "id": 145,
    "slot": 0,
    "url": "/pages/demo?view=oppervlakte-studio&ontwerp=1",
    "price": 5.99,
    "title": "Hoeveel pakken parket heb je nodig?",
    "body": "Vul de lengte en breedte van je kamer in. Het legverlies telt mee bij het afronden op hele pakken.",
    "photo": "jdq-interior.jpg",
    "previewAsset": "jd-branche-145-1.webp"
   },
   {
    "label": "Muurverf in lagen",
    "id": 145,
    "slot": 1,
    "url": "/pages/demo?view=oppervlakte-studio&ontwerp=2",
    "price": 5.99,
    "title": "Hoeveel blikken voor jouw kleur?",
    "body": "Vul het te schilderen oppervlak in. Kies je aantal lagen, dekking per liter en blikinhoud.",
    "photo": "jd-physical-kleurenwaaier.webp",
    "previewAsset": "jd-branche-145-2.webp"
   },
   {
    "label": "Travertin voor de badkamer",
    "id": 145,
    "slot": 2,
    "url": "/pages/demo?view=oppervlakte-studio&ontwerp=3",
    "price": 5.99,
    "title": "Hoeveel tegels bestel je?",
    "body": "Bereken met je tegelmaat, oppervlakte en snijverlies hoeveel hele tegels je nodig hebt.",
    "photo": "jd-approved-05-travertin.webp",
    "previewAsset": "jd-branche-145-3.webp"
   },
   {
    "label": "Grond voor de border",
    "id": 145,
    "slot": 3,
    "url": "/pages/demo?view=oppervlakte-studio&ontwerp=4",
    "price": 5.99,
    "title": "Hoeveel grond past in je border?",
    "body": "Meet de binnenmaat en vul de laagdikte in meters in. Bekijk de uitkomst in kuubs en liters.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-145-4.webp"
   }
  ],
  "productId": 145,
  "basePrice": 5.99,
  "editorRoute": "/pages/demo?view=oppervlakte-studio",
  "cover": 0,
  "legacyOptions": [
   {
    "label": "Vloeren · pakken per ruimte",
    "url": "/pages/demo?view=oppervlakte-studio&ontwerp=1",
    "price": 5.99,
    "id": 145
   },
   {
    "label": "Tegels · reserve en snijverlies",
    "url": "/pages/demo?view=reserve-studio&ontwerp=4",
    "price": 3.99,
    "id": 146
   },
   {
    "label": "Tuinaanleg · volume",
    "url": "/pages/demo?view=volume-studio&ontwerp=2",
    "price": 3.99,
    "id": 147
   },
   {
    "label": "Schilderwerk · verf en coating",
    "url": "/pages/demo?view=verf-studio&ontwerp=3",
    "price": 7.99,
    "id": 148
   }
  ],
  "imageAsset": "jd-branche-145-1.webp"
 },
 {
  "name": "Productvergelijker",
  "description": "Zet eigenschappen van producten naast elkaar.",
  "branch": "Detailhandel",
  "task": "Vergelijken",
  "goal": "Helpen kiezen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-55-2.webp",
  "options": [
   {
    "label": "Productvergelijker",
    "id": 55,
    "price": 7.99,
    "url": "/pages/demo?view=producten-vergelijken-studio"
   }
  ],
  "presets": [
   {
    "label": "Verlichting",
    "id": 55,
    "slot": 0,
    "url": "/pages/demo?view=producten-vergelijken-studio&ontwerp=1",
    "price": 7.99,
    "title": "Welke lamp past bij je leeshoek?",
    "body": "Vergelijk lichtopbrengst, kleurtemperatuur en afwerking naast elkaar.",
    "photo": "jdb-lamp.jpg",
    "previewAsset": "jd-branche-55-1.webp"
   },
   {
    "label": "Natuursteen",
    "id": 55,
    "slot": 1,
    "url": "/pages/demo?view=producten-vergelijken-studio&ontwerp=2",
    "price": 7.99,
    "title": "Welke steen past bij jouw badkamer?",
    "body": "Vergelijk drie afwerkingen op oppervlak, formaat en onderhoud.",
    "photo": "jd-approved-05-travertin.webp",
    "previewAsset": "jd-branche-55-2.webp"
   },
   {
    "label": "Koffie",
    "id": 55,
    "slot": 2,
    "url": "/pages/demo?view=producten-vergelijken-studio&ontwerp=3",
    "price": 7.99,
    "title": "Welke koffie past in je ochtendritueel?",
    "body": "Bekijk de verschillen in branding, herkomst en smaak.",
    "photo": "jd-approved-14-espresso.webp",
    "previewAsset": "jd-branche-55-3.webp"
   },
   {
    "label": "Werkschoenen",
    "id": 55,
    "slot": 3,
    "url": "/pages/demo?view=producten-vergelijken-studio&ontwerp=4",
    "price": 7.99,
    "title": "Welke schoen draag je tijdens je werkdag?",
    "body": "Leg materiaal, sluiting en zool van de modellen naast elkaar.",
    "photo": "jd-approved-06-sneaker.webp",
    "previewAsset": "jd-branche-55-4.webp"
   }
  ],
  "productId": 55,
  "basePrice": 7.99,
  "editorRoute": "/pages/demo?view=producten-vergelijken-studio",
  "cover": 1,
  "legacyOptions": [
   {
    "label": "Producten vergelijken",
    "url": "/pages/demo?view=producten-vergelijken-studio",
    "price": 7.99,
    "id": 55
   },
   {
    "label": "Uitgebreide handmatige productvergelijker",
    "url": "/pages/demo?view=uitgebreidvergelijken-studio",
    "price": 14.99,
    "id": 165
   }
  ],
  "imageAsset": "jd-branche-55-2.webp"
 },
 {
  "name": "Keuzehulp",
  "description": "Leid bezoekers met gerichte vragen naar een passend advies.",
  "branch": "Detailhandel",
  "task": "Adviseren",
  "goal": "Helpen kiezen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-157-1.webp",
  "options": [
   {
    "label": "Keuzehulp",
    "id": 157,
    "price": 9.99,
    "url": "/pages/demo?view=pakket-studio"
   }
  ],
  "presets": [
   {
    "label": "Personal training",
    "id": 157,
    "slot": 0,
    "url": "/pages/demo?view=pakket-studio&ontwerp=1",
    "price": 9.99,
    "title": "Vind een training die bij je past",
    "body": "Kies je doel, ervaring en beschikbare tijd voor een passend trainingsadvies.",
    "photo": "jdp-trainer.jpg",
    "previewAsset": "jd-branche-157-1.webp"
   },
   {
    "label": "Sportcoaching",
    "id": 157,
    "slot": 1,
    "url": "/pages/demo?view=pakket-studio&ontwerp=2",
    "price": 9.99,
    "title": "Welke begeleiding helpt je verder?",
    "body": "Kies je voorkeuren en ontdek met welk traject je kunt starten.",
    "photo": "jdp-coach.jpg",
    "previewAsset": "jd-branche-157-2.webp"
   },
   {
    "label": "Groepstraining",
    "id": 157,
    "slot": 2,
    "url": "/pages/demo?view=pakket-studio&ontwerp=3",
    "price": 9.99,
    "title": "Welke groep past bij jouw tempo?",
    "body": "Vertel hoe je graag traint en bekijk het aanbod dat bij je past.",
    "photo": "jdp-group.jpg",
    "previewAsset": "jd-branche-157-3.webp"
   },
   {
    "label": "Trainingsplan",
    "id": 157,
    "slot": 3,
    "url": "/pages/demo?view=pakket-studio&ontwerp=4",
    "price": 9.99,
    "title": "Plan je volgende trainingsblok",
    "body": "Stem het pakket af op je ritme, trainingsdoel en niveau.",
    "photo": "jdp-training.jpg",
    "previewAsset": "jd-branche-157-4.webp"
   }
  ],
  "productId": 157,
  "basePrice": 9.99,
  "editorRoute": "/pages/demo?view=pakket-studio",
  "cover": 0,
  "legacyOptions": [
   {
    "label": "Productkeuzehulp met vaste regels",
    "url": "/pages/demo?view=pakket-studio",
    "price": 9.99,
    "id": 157
   },
   {
    "label": "Cadeauzoeker met vaste keuzes",
    "url": "/pages/demo?view=cadeauzoeker-studio",
    "price": 5.99,
    "id": 158
   }
  ],
  "imageAsset": "jd-branche-157-1.webp"
 },
 {
  "name": "Productaanbevelingen",
  "description": "Toon bijpassende artikelen of laat klanten een set afmaken.",
  "branch": "Detailhandel",
  "task": "Adviseren",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-85-3.webp",
  "options": [
   {
    "label": "Productaanbevelingen",
    "id": 85,
    "price": 7.99,
    "url": "/pages/demo?view=samen-gekocht-studio"
   }
  ],
  "presets": [
   {
    "label": "Leeshoek",
    "id": 85,
    "slot": 0,
    "url": "/pages/demo?view=samen-gekocht-studio&ontwerp=1",
    "price": 7.99,
    "title": "Maak je leeshoek compleet",
    "body": "Bekijk de verlichting en accessoires die bij je zitplek passen.",
    "photo": "jdb-sofa.jpg",
    "previewAsset": "jd-branche-85-1.webp"
   },
   {
    "label": "Tuinatelier",
    "id": 85,
    "slot": 1,
    "url": "/pages/demo?view=samen-gekocht-studio&ontwerp=2",
    "price": 7.99,
    "title": "Stel je groene hoek samen",
    "body": "Selecteer de aanvullingen die passen bij je planten en de plek waar ze staan.",
    "photo": "jd-physical-plant.webp",
    "previewAsset": "jd-branche-85-2.webp"
   },
   {
    "label": "Koffiebar",
    "id": 85,
    "slot": 2,
    "url": "/pages/demo?view=samen-gekocht-studio&ontwerp=3",
    "price": 7.99,
    "title": "Alles voor je koffiemoment",
    "body": "Kies een aanvulling voor je koffiehoek en bekijk de complete selectie.",
    "photo": "jd-approved-14-espresso.webp",
    "previewAsset": "jd-branche-85-3.webp"
   },
   {
    "label": "Werkplaats",
    "id": 85,
    "slot": 3,
    "url": "/pages/demo?view=samen-gekocht-studio&ontwerp=4",
    "price": 7.99,
    "title": "Wat heb je nodig op locatie?",
    "body": "Selecteer de aanvullingen voor meten, voorbereiden en monteren.",
    "photo": "jd-physical-gereedschapskist.webp",
    "previewAsset": "jd-branche-85-4.webp"
   }
  ],
  "productId": 85,
  "basePrice": 7.99,
  "editorRoute": "/pages/demo?view=samen-gekocht-studio",
  "cover": 2,
  "legacyOptions": [
   {
    "label": "Vaak samen gekocht",
    "url": "/pages/demo?view=samen-gekocht-studio",
    "price": 7.99,
    "id": 85
   },
   {
    "label": "Maak je set compleet",
    "url": "/pages/demo?view=set-compleet-studio",
    "price": 7.99,
    "id": 86
   }
  ],
  "imageAsset": "jd-branche-85-3.webp"
 },
 {
  "name": "Offertetool",
  "description": "Verzamel projectgegevens of een aanvraag met orderregels.",
  "branch": "Zakelijk",
  "task": "Aanvragen",
  "goal": "Aanvragen ontvangen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-134-1.webp",
  "options": [
   {
    "label": "Offertetool",
    "id": 134,
    "price": 9.99,
    "url": "/pages/demo?view=offertestappen-studio"
   }
  ],
  "presets": [
   {
    "label": "Interieuradvies",
    "id": 134,
    "slot": 0,
    "url": "/pages/demo?view=offertestappen-studio&ontwerp=1",
    "price": 9.99,
    "title": "Vraag een voorstel voor je interieur",
    "body": "Beschrijf de ruimte, de gewenste afwerking en je planning.",
    "photo": "jd-showcase-living.jpg",
    "previewAsset": "jd-branche-134-1.webp"
   },
   {
    "label": "Tuinontwerp",
    "id": 134,
    "slot": 1,
    "url": "/pages/demo?view=offertestappen-studio&ontwerp=2",
    "price": 9.99,
    "title": "Een offerte voor jouw buitenruimte",
    "body": "Geef de afmetingen en gewenste werkzaamheden door.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-134-2.webp"
   },
   {
    "label": "Textielatelier",
    "id": 134,
    "slot": 2,
    "url": "/pages/demo?view=offertestappen-studio&ontwerp=3",
    "price": 9.99,
    "title": "Wat mogen we voor je maken?",
    "body": "Kies een stof, benoem het aantal en voeg je wensen toe.",
    "photo": "jd-physical-stofstalen.webp",
    "previewAsset": "jd-branche-134-3.webp"
   },
   {
    "label": "Montagebedrijf",
    "id": 134,
    "slot": 3,
    "url": "/pages/demo?view=offertestappen-studio&ontwerp=4",
    "price": 9.99,
    "title": "Vraag montage op locatie aan",
    "body": "Leg de werkzaamheden, aantallen en gewenste uitvoerdatum vast.",
    "photo": "jd-physical-gereedschapskist.webp",
    "previewAsset": "jd-branche-134-4.webp"
   }
  ],
  "productId": 134,
  "basePrice": 9.99,
  "editorRoute": "/pages/demo?view=offertestappen-studio",
  "cover": 0,
  "legacyOptions": [
   {
    "label": "Offerteformulier in stappen",
    "url": "/pages/demo?view=offertestappen-studio",
    "price": 9.99,
    "id": 134
   },
   {
    "label": "Zakelijke aanvraag met orderregels",
    "url": "/pages/demo?view=zakelijkeaanvraag-studio",
    "price": 9.99,
    "id": 143
   }
  ],
  "imageAsset": "jd-branche-134-1.webp"
 },
 {
  "name": "Schuttingstudio",
  "description": "Stel een schutting samen en bekijk het ontwerp en de prijsopbouw.",
  "branch": "Tuin",
  "task": "Configureren",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-162-1.webp",
  "options": [
   {
    "label": "Schuttingstudio",
    "id": 162,
    "price": 14.99,
    "url": "/pages/demo?view=tool-162-studio"
   }
  ],
  "presets": [
   {
    "label": "Douglas",
    "id": 162,
    "slot": 0,
    "url": "/pages/demo?view=tool-162-studio&ontwerp=1",
    "price": 14.99,
    "title": "Een rechte schutting langs je tuin",
    "body": "Stel je schermen, palen en afwerking samen.",
    "photo": "jd-fence-material-screen.webp",
    "previewAsset": "jd-branche-162-1.webp"
   },
   {
    "label": "Hoektuin",
    "id": 162,
    "slot": 1,
    "url": "/pages/demo?view=tool-162-studio&ontwerp=2",
    "price": 14.99,
    "title": "Bereken een erfafscheiding met hoek",
    "body": "Meet beide zijden en kies je hoekopstelling.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-162-2.webp"
   },
   {
    "label": "Tuin met poort",
    "id": 162,
    "slot": 2,
    "url": "/pages/demo?view=tool-162-studio&ontwerp=3",
    "price": 14.99,
    "title": "Ruimte voor een toegangspoort",
    "body": "Bepaal waar je toegang nodig hebt en bekijk de materialen.",
    "photo": "jd-fence-material-post.webp",
    "previewAsset": "jd-branche-162-3.webp"
   },
   {
    "label": "Erfafscheiding",
    "id": 162,
    "slot": 3,
    "url": "/pages/demo?view=tool-162-studio&ontwerp=4",
    "price": 14.99,
    "title": "Stel je materiaalstaat samen",
    "body": "Vergelijk het benodigde materiaal voor de zijden van je tuin.",
    "photo": "jd-fence-material-plate.webp",
    "previewAsset": "jd-branche-162-4.webp"
   }
  ],
  "productId": 162,
  "basePrice": 14.99,
  "editorRoute": "/pages/demo?view=tool-162-studio",
  "cover": 0,
  "legacyOptions": [
   {
    "label": "Schuttingstudio",
    "url": "/pages/demo?view=tool-162-studio",
    "price": 14.99,
    "id": 162
   }
  ],
  "imageAsset": "jd-branche-162-1.webp"
 },
 {
  "name": "Verzendkostencalculator",
  "description": "Verzendkosten vooraf berekenen.",
  "branch": "Branchebreed",
  "task": "Berekenen",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-122-3.webp",
  "options": [
   {
    "label": "Verzendkostencalculator",
    "id": 122,
    "price": 7.99,
    "url": "/pages/demo?view=verzendberekening-studio"
   }
  ],
  "presets": [
   {
    "label": "Meubelbezorging",
    "id": 122,
    "slot": 0,
    "url": "/pages/demo?view=verzendberekening-studio&ontwerp=1",
    "price": 7.99,
    "title": "Wat kost bezorgen aan huis?",
    "body": "Vul het bestelbedrag en de bezorggegevens voor jouw meubels in.",
    "photo": "jdb-sofa.jpg",
    "previewAsset": "jd-branche-122-1.webp"
   },
   {
    "label": "Tuinwinkel",
    "id": 122,
    "slot": 1,
    "url": "/pages/demo?view=verzendberekening-studio&ontwerp=2",
    "price": 7.99,
    "title": "Wat kost transport naar je tuin?",
    "body": "Bereken de bezorgindicatie voor een bestelling tuinmaterialen.",
    "photo": "jd-physical-plant.webp",
    "previewAsset": "jd-branche-122-2.webp"
   },
   {
    "label": "Chocolaterie",
    "id": 122,
    "slot": 2,
    "url": "/pages/demo?view=verzendberekening-studio&ontwerp=3",
    "price": 7.99,
    "title": "Wat kost het versturen van je cadeau?",
    "body": "Controleer de verzendkosten voor jouw geschenkbestelling.",
    "photo": "jd-approved-01-chocolade.webp",
    "previewAsset": "jd-branche-122-3.webp"
   },
   {
    "label": "Groothandel",
    "id": 122,
    "slot": 3,
    "url": "/pages/demo?view=verzendberekening-studio&ontwerp=4",
    "price": 7.99,
    "title": "Bereken je transportkosten",
    "body": "Bekijk de transportindicatie voor je zakelijke bestelling.",
    "photo": "jd-approved-15-heftruck.webp",
    "previewAsset": "jd-branche-122-4.webp"
   }
  ],
  "productId": 122,
  "basePrice": 7.99,
  "editorRoute": "/pages/demo?view=verzendberekening-studio",
  "cover": 2,
  "legacyOptions": [
   {
    "label": "Verzendkosten vooraf berekenen",
    "url": "/pages/demo?view=verzendberekening-studio",
    "price": 7.99,
    "id": 122
   }
  ],
  "imageAsset": "jd-branche-122-3.webp"
 },
 {
  "name": "Bezorggebied controleren",
  "description": "Postcodecontrole voor bezorggebied.",
  "branch": "Branchebreed",
  "task": "Controleren",
  "goal": "Helpen kiezen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-123-3.webp",
  "options": [
   {
    "label": "Bezorggebied controleren",
    "id": 123,
    "price": 3.99,
    "url": "/pages/demo?view=postcodegebied-studio"
   }
  ],
  "presets": [
   {
    "label": "Woonwinkel",
    "id": 123,
    "slot": 0,
    "url": "/pages/demo?view=postcodegebied-studio&ontwerp=1",
    "price": 3.99,
    "title": "Bezorgen we bij jou thuis?",
    "body": "Controleer je postcode voordat je een bezorgmoment kiest.",
    "photo": "jdq-interior.jpg",
    "previewAsset": "jd-branche-123-1.webp"
   },
   {
    "label": "Tuinservice",
    "id": 123,
    "slot": 1,
    "url": "/pages/demo?view=postcodegebied-studio&ontwerp=2",
    "price": 3.99,
    "title": "Werken we in jouw tuin?",
    "body": "Controleer of je adres binnen het werkgebied valt.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-123-2.webp"
   },
   {
    "label": "Bloemist",
    "id": 123,
    "slot": 2,
    "url": "/pages/demo?view=postcodegebied-studio&ontwerp=3",
    "price": 3.99,
    "title": "Kunnen we hier bloemen bezorgen?",
    "body": "Vul de postcode in van de ontvanger van het boeket.",
    "photo": "jd-approved-09-roos.webp",
    "previewAsset": "jd-branche-123-3.webp"
   },
   {
    "label": "Koffiebranderij",
    "id": 123,
    "slot": 3,
    "url": "/pages/demo?view=postcodegebied-studio&ontwerp=4",
    "price": 3.99,
    "title": "Valt jouw adres op de koffieroute?",
    "body": "Bekijk of onze lokale bezorging bij je langskomt.",
    "photo": "jd-approved-14-espresso.webp",
    "previewAsset": "jd-branche-123-4.webp"
   }
  ],
  "productId": 123,
  "basePrice": 3.99,
  "editorRoute": "/pages/demo?view=postcodegebied-studio",
  "cover": 2,
  "legacyOptions": [
   {
    "label": "Postcodecontrole voor bezorggebied",
    "url": "/pages/demo?view=postcodegebied-studio",
    "price": 3.99,
    "id": 123
   }
  ],
  "imageAsset": "jd-branche-123-3.webp"
 },
 {
  "name": "Formulier met vervolgvragen",
  "description": "Formulier met vervolgvragen.",
  "branch": "Branchebreed",
  "task": "Aanvragen",
  "goal": "Aanvragen ontvangen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-135-1.webp",
  "options": [
   {
    "label": "Formulier met vervolgvragen",
    "id": 135,
    "price": 7.99,
    "url": "/pages/demo?view=vervolgvragen-studio"
   }
  ],
  "presets": [
   {
    "label": "Interieurstudio",
    "id": 135,
    "slot": 0,
    "url": "/pages/demo?view=vervolgvragen-studio&ontwerp=1",
    "price": 7.99,
    "title": "Vertel ons over je kamer",
    "body": "Beantwoord de vragen over de ruimte en je wensen.",
    "photo": "jd-showcase-interior.jpg",
    "previewAsset": "jd-branche-135-1.webp"
   },
   {
    "label": "Hovenier",
    "id": 135,
    "slot": 1,
    "url": "/pages/demo?view=vervolgvragen-studio&ontwerp=2",
    "price": 7.99,
    "title": "Wat wil je met je tuin doen?",
    "body": "Geef aan wat er al staat en waar je hulp bij zoekt.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-135-2.webp"
   },
   {
    "label": "Stoffeerderij",
    "id": 135,
    "slot": 2,
    "url": "/pages/demo?view=vervolgvragen-studio&ontwerp=3",
    "price": 7.99,
    "title": "Welk meubel wil je laten stofferen?",
    "body": "Kies het type meubel en vertel welke stof je zoekt.",
    "photo": "jd-physical-stofstalen.webp",
    "previewAsset": "jd-branche-135-3.webp"
   },
   {
    "label": "Montageteam",
    "id": 135,
    "slot": 3,
    "url": "/pages/demo?view=vervolgvragen-studio&ontwerp=4",
    "price": 7.99,
    "title": "Bereid je montageafspraak voor",
    "body": "Beschrijf de locatie en de werkzaamheden voor de monteur.",
    "photo": "jd-physical-gereedschapskist.webp",
    "previewAsset": "jd-branche-135-4.webp"
   }
  ],
  "productId": 135,
  "basePrice": 7.99,
  "editorRoute": "/pages/demo?view=vervolgvragen-studio",
  "cover": 0,
  "legacyOptions": [
   {
    "label": "Formulier met vervolgvragen",
    "url": "/pages/demo?view=vervolgvragen-studio",
    "price": 7.99,
    "id": 135
   }
  ],
  "imageAsset": "jd-branche-135-1.webp"
 },
 {
  "name": "Prijscalculator",
  "description": "Prijsindicatie voor diensten.",
  "branch": "Branchebreed",
  "task": "Berekenen",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-149-1.webp",
  "options": [
   {
    "label": "Prijscalculator",
    "id": 149,
    "price": 9.99,
    "url": "/pages/demo?view=offerte-studio"
   }
  ],
  "presets": [
   {
    "label": "Interieuradvies",
    "id": 149,
    "slot": 0,
    "url": "/pages/demo?view=offerte-studio&ontwerp=1",
    "price": 9.99,
    "title": "Bereken de prijs van jouw advies",
    "body": "Kies werkzaamheden en uren voor een indicatie vooraf.",
    "photo": "jd-showcase-living.jpg",
    "previewAsset": "jd-branche-149-1.webp"
   },
   {
    "label": "Tuinonderhoud",
    "id": 149,
    "slot": 1,
    "url": "/pages/demo?view=offerte-studio&ontwerp=2",
    "price": 9.99,
    "title": "Wat kost een onderhoudsbeurt?",
    "body": "Selecteer het werk en de tijd die je wilt reserveren.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-149-2.webp"
   },
   {
    "label": "Naaiatelier",
    "id": 149,
    "slot": 2,
    "url": "/pages/demo?view=offerte-studio&ontwerp=3",
    "price": 9.99,
    "title": "Bereken je atelieropdracht",
    "body": "Stel de werkzaamheden voor je textielopdracht samen.",
    "photo": "jd-approved-12-schaar.webp",
    "previewAsset": "jd-branche-149-3.webp"
   },
   {
    "label": "Montageservice",
    "id": 149,
    "slot": 3,
    "url": "/pages/demo?view=offerte-studio&ontwerp=4",
    "price": 9.99,
    "title": "Wat kost montage op locatie?",
    "body": "Kies de werkzaamheden en bereken de richtprijs.",
    "photo": "jd-physical-gereedschapskist.webp",
    "previewAsset": "jd-branche-149-4.webp"
   }
  ],
  "productId": 149,
  "basePrice": 9.99,
  "editorRoute": "/pages/demo?view=offerte-studio",
  "cover": 0,
  "legacyOptions": [
   {
    "label": "Prijsindicatie voor diensten",
    "url": "/pages/demo?view=offerte-studio",
    "price": 9.99,
    "id": 149
   }
  ],
  "imageAsset": "jd-branche-149-1.webp"
 },
 {
  "name": "Budgetplanner",
  "description": "Budgetplanner.",
  "branch": "Branchebreed",
  "task": "Plannen",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-150-3.webp",
  "options": [
   {
    "label": "Budgetplanner",
    "id": 150,
    "price": 5.99,
    "url": "/pages/demo?view=budget-studio"
   }
  ],
  "presets": [
   {
    "label": "Woonkamer",
    "id": 150,
    "slot": 0,
    "url": "/pages/demo?view=budget-studio&ontwerp=1",
    "price": 5.99,
    "title": "Wat past binnen je woonbudget?",
    "body": "Verdeel je budget over de meubels en accessoires.",
    "photo": "jdb-sofa.jpg",
    "previewAsset": "jd-branche-150-1.webp"
   },
   {
    "label": "Terras",
    "id": 150,
    "slot": 1,
    "url": "/pages/demo?view=budget-studio&ontwerp=2",
    "price": 5.99,
    "title": "Plan de uitgaven voor je terras",
    "body": "Kies de materialen die je binnen je budget wilt opnemen.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-150-2.webp"
   },
   {
    "label": "Koffiehoek",
    "id": 150,
    "slot": 2,
    "url": "/pages/demo?view=budget-studio&ontwerp=3",
    "price": 5.99,
    "title": "Richt je koffiehoek in",
    "body": "Kies apparatuur en accessoires en bekijk wat je kunt besteden.",
    "photo": "jd-approved-14-espresso.webp",
    "previewAsset": "jd-branche-150-3.webp"
   },
   {
    "label": "Werkplaats",
    "id": 150,
    "slot": 3,
    "url": "/pages/demo?view=budget-studio&ontwerp=4",
    "price": 5.99,
    "title": "Verdeel je werkplaatsbudget",
    "body": "Kies de benodigdheden en houd je resterende budget in beeld.",
    "photo": "jd-physical-gereedschapskist.webp",
    "previewAsset": "jd-branche-150-4.webp"
   }
  ],
  "productId": 150,
  "basePrice": 5.99,
  "editorRoute": "/pages/demo?view=budget-studio",
  "cover": 2,
  "legacyOptions": [
   {
    "label": "Budgetplanner",
    "url": "/pages/demo?view=budget-studio",
    "price": 5.99,
    "id": 150
   }
  ],
  "imageAsset": "jd-branche-150-3.webp"
 },
 {
  "name": "Kosten per gebruik",
  "description": "Kosten per gebruik.",
  "branch": "Branchebreed",
  "task": "Berekenen",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-151-3.webp",
  "options": [
   {
    "label": "Kosten per gebruik",
    "id": 151,
    "price": 3.99,
    "url": "/pages/demo?view=gebruik-studio"
   }
  ],
  "presets": [
   {
    "label": "Meubels",
    "id": 151,
    "slot": 0,
    "url": "/pages/demo?view=gebruik-studio&ontwerp=1",
    "price": 3.99,
    "title": "Wat kost je bank per gebruiksdag?",
    "body": "Verdeel de aankoopprijs over de periode waarin je de bank gebruikt.",
    "photo": "jdb-sofa.jpg",
    "previewAsset": "jd-branche-151-1.webp"
   },
   {
    "label": "Tuinmachine",
    "id": 151,
    "slot": 1,
    "url": "/pages/demo?view=gebruik-studio&ontwerp=2",
    "price": 3.99,
    "title": "Wat kost je machine per beurt?",
    "body": "Vul prijs, levensduur en gebruiksfrequentie in.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-151-2.webp"
   },
   {
    "label": "Koffieapparaat",
    "id": 151,
    "slot": 2,
    "url": "/pages/demo?view=gebruik-studio&ontwerp=3",
    "price": 3.99,
    "title": "Wat kost je machine per kop?",
    "body": "Verdeel de aanschaf over het verwachte aantal koffiemomenten.",
    "photo": "jd-approved-14-espresso.webp",
    "previewAsset": "jd-branche-151-3.webp"
   },
   {
    "label": "Gereedschap",
    "id": 151,
    "slot": 3,
    "url": "/pages/demo?view=gebruik-studio&ontwerp=4",
    "price": 3.99,
    "title": "Wat kost dit gereedschap per klus?",
    "body": "Vergelijk de aanschaf met het aantal geplande klussen.",
    "photo": "jd-physical-gereedschapskist.webp",
    "previewAsset": "jd-branche-151-4.webp"
   }
  ],
  "productId": 151,
  "basePrice": 3.99,
  "editorRoute": "/pages/demo?view=gebruik-studio",
  "cover": 2,
  "legacyOptions": [
   {
    "label": "Kosten per gebruik",
    "url": "/pages/demo?view=gebruik-studio",
    "price": 3.99,
    "id": 151
   }
  ],
  "imageAsset": "jd-branche-151-3.webp"
 },
 {
  "name": "Besparingscalculator",
  "description": "Besparingscalculator.",
  "branch": "Branchebreed",
  "task": "Berekenen",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-152-1.webp",
  "options": [
   {
    "label": "Besparingscalculator",
    "id": 152,
    "price": 7.99,
    "url": "/pages/demo?view=besparing-studio"
   }
  ],
  "presets": [
   {
    "label": "Leeslamp",
    "id": 152,
    "slot": 0,
    "url": "/pages/demo?view=besparing-studio&ontwerp=1",
    "price": 7.99,
    "title": "Wat scheelt een andere leeslamp?",
    "body": "Vergelijk vermogen en branduren tegen je eigen stroomtarief.",
    "photo": "jdb-lamp.jpg",
    "previewAsset": "jd-branche-152-1.webp"
   },
   {
    "label": "Tuinverlichting",
    "id": 152,
    "slot": 1,
    "url": "/pages/demo?view=besparing-studio&ontwerp=2",
    "price": 7.99,
    "title": "Wat verbruikt jouw buitenlicht?",
    "body": "Vul de brandtijd van je tuinverlichting in.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-152-2.webp"
   },
   {
    "label": "Etalage",
    "id": 152,
    "slot": 2,
    "url": "/pages/demo?view=besparing-studio&ontwerp=3",
    "price": 7.99,
    "title": "Wat scheelt nieuwe etalageverlichting?",
    "body": "Vergelijk de vermogens bij de openingstijden van je winkel.",
    "photo": "jd-showcase-living.jpg",
    "previewAsset": "jd-branche-152-3.webp"
   },
   {
    "label": "Werkplaats",
    "id": 152,
    "slot": 3,
    "url": "/pages/demo?view=besparing-studio&ontwerp=4",
    "price": 7.99,
    "title": "Hoeveel bespaar je op werklicht?",
    "body": "Reken met de branduren en het tarief van je werkplaats.",
    "photo": "jd-physical-gereedschapskist.webp",
    "previewAsset": "jd-branche-152-4.webp"
   }
  ],
  "productId": 152,
  "basePrice": 7.99,
  "editorRoute": "/pages/demo?view=besparing-studio",
  "cover": 0,
  "legacyOptions": [
   {
    "label": "Besparingscalculator",
    "url": "/pages/demo?view=besparing-studio",
    "price": 7.99,
    "id": 152
   }
  ],
  "imageAsset": "jd-branche-152-1.webp"
 },
 {
  "name": "Rendementscalculator",
  "description": "Rendementsindicatie.",
  "branch": "Branchebreed",
  "task": "Berekenen",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-153-3.webp",
  "options": [
   {
    "label": "Rendementscalculator",
    "id": 153,
    "price": 7.99,
    "url": "/pages/demo?view=rendement-studio"
   }
  ],
  "presets": [
   {
    "label": "Meubelverhuur",
    "id": 153,
    "slot": 0,
    "url": "/pages/demo?view=rendement-studio&ontwerp=1",
    "price": 7.99,
    "title": "Wat brengt dit verhuurmeubel op?",
    "body": "Zet de investering, kosten en verwachte opbrengsten naast elkaar.",
    "photo": "jdb-sofa.jpg",
    "previewAsset": "jd-branche-153-1.webp"
   },
   {
    "label": "Tuinmaterieel",
    "id": 153,
    "slot": 1,
    "url": "/pages/demo?view=rendement-studio&ontwerp=2",
    "price": 7.99,
    "title": "Reken je materieelinvestering door",
    "body": "Vul je aanschaf en verwachte jaarlijkse opbrengst in.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-153-2.webp"
   },
   {
    "label": "Koffiebar",
    "id": 153,
    "slot": 2,
    "url": "/pages/demo?view=rendement-studio&ontwerp=3",
    "price": 7.99,
    "title": "Reken je koffiemachine door",
    "body": "Maak een indicatie op basis van jouw investering en verwachte opbrengst.",
    "photo": "jd-approved-14-espresso.webp",
    "previewAsset": "jd-branche-153-3.webp"
   },
   {
    "label": "Werkplaats",
    "id": 153,
    "slot": 3,
    "url": "/pages/demo?view=rendement-studio&ontwerp=4",
    "price": 7.99,
    "title": "Wanneer verdient een machine zich terug?",
    "body": "Vergelijk je jaarlijkse kosten en opbrengsten met het investeringsbedrag.",
    "photo": "jd-physical-gereedschapskist.webp",
    "previewAsset": "jd-branche-153-4.webp"
   }
  ],
  "productId": 153,
  "basePrice": 7.99,
  "editorRoute": "/pages/demo?view=rendement-studio",
  "cover": 2,
  "legacyOptions": [
   {
    "label": "Rendementsindicatie",
    "url": "/pages/demo?view=rendement-studio",
    "price": 7.99,
    "id": 153
   }
  ],
  "imageAsset": "jd-branche-153-3.webp"
 },
 {
  "name": "Verpakkingsplanner",
  "description": "Verpakkingsplanner.",
  "branch": "Branchebreed",
  "task": "Plannen",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-155-4.webp",
  "options": [
   {
    "label": "Verpakkingsplanner",
    "id": 155,
    "price": 5.99,
    "url": "/pages/demo?view=verpakking-studio"
   }
  ],
  "presets": [
   {
    "label": "Verlichting",
    "id": 155,
    "slot": 0,
    "url": "/pages/demo?view=verpakking-studio&ontwerp=1",
    "price": 5.99,
    "title": "Hoeveel dozen voor je lampen?",
    "body": "Vul het aantal lampen en de capaciteit per doos en pallet in.",
    "photo": "jdb-lamp.jpg",
    "previewAsset": "jd-branche-155-1.webp"
   },
   {
    "label": "Kwekerij",
    "id": 155,
    "slot": 1,
    "url": "/pages/demo?view=verpakking-studio&ontwerp=2",
    "price": 5.99,
    "title": "Hoeveel pallets voor je planten?",
    "body": "Plan de verzending op basis van aantallen per verpakking.",
    "photo": "jd-physical-plant.webp",
    "previewAsset": "jd-branche-155-2.webp"
   },
   {
    "label": "Chocolaterie",
    "id": 155,
    "slot": 2,
    "url": "/pages/demo?view=verpakking-studio&ontwerp=3",
    "price": 5.99,
    "title": "Plan je geschenkverpakkingen",
    "body": "Bereken het benodigde aantal omdozen voor je cadeaureeks.",
    "photo": "jd-approved-01-chocolade.webp",
    "previewAsset": "jd-branche-155-3.webp"
   },
   {
    "label": "Magazijn",
    "id": 155,
    "slot": 3,
    "url": "/pages/demo?view=verpakking-studio&ontwerp=4",
    "price": 5.99,
    "title": "Maak je palletplanning",
    "body": "Reken van een bestelaantal naar hele dozen en pallets.",
    "photo": "jd-approved-15-heftruck.webp",
    "previewAsset": "jd-branche-155-4.webp"
   }
  ],
  "productId": 155,
  "basePrice": 5.99,
  "editorRoute": "/pages/demo?view=verpakking-studio",
  "cover": 3,
  "legacyOptions": [
   {
    "label": "Verpakkingsplanner",
    "url": "/pages/demo?view=verpakking-studio",
    "price": 5.99,
    "id": 155
   }
  ],
  "imageAsset": "jd-branche-155-4.webp"
 },
 {
  "name": "Maatadvies",
  "description": "Maatadvies met tabelregels.",
  "branch": "Branchebreed",
  "task": "Adviseren",
  "goal": "Helpen kiezen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-159-3.webp",
  "options": [
   {
    "label": "Maatadvies",
    "id": 159,
    "price": 7.99,
    "url": "/pages/demo?view=maatadvies-studio"
   }
  ],
  "presets": [
   {
    "label": "Tafelmaat",
    "id": 159,
    "slot": 0,
    "url": "/pages/demo?view=maatadvies-studio&ontwerp=1",
    "price": 7.99,
    "title": "Welke maat past bij je eethoek?",
    "body": "Vergelijk de maten en bekijk het advies voor jouw ruimte.",
    "photo": "jdb-table.jpg",
    "previewAsset": "jd-branche-159-1.webp"
   },
   {
    "label": "Kwekerij",
    "id": 159,
    "slot": 1,
    "url": "/pages/demo?view=maatadvies-studio&ontwerp=2",
    "price": 7.99,
    "title": "Kies de maat voor je plant",
    "body": "Gebruik de maatgegevens om een passende uitvoering te kiezen.",
    "photo": "jd-physical-plant.webp",
    "previewAsset": "jd-branche-159-2.webp"
   },
   {
    "label": "Schoenen",
    "id": 159,
    "slot": 2,
    "url": "/pages/demo?view=maatadvies-studio&ontwerp=3",
    "price": 7.99,
    "title": "Vind je schoenmaat",
    "body": "Vergelijk je meting met de maten van de collectie.",
    "photo": "jd-approved-06-sneaker.webp",
    "previewAsset": "jd-branche-159-3.webp"
   },
   {
    "label": "Stoffen",
    "id": 159,
    "slot": 3,
    "url": "/pages/demo?view=maatadvies-studio&ontwerp=4",
    "price": 7.99,
    "title": "Welke textielmaat heb je nodig?",
    "body": "Controleer de maten voordat je jouw uitvoering kiest.",
    "photo": "jd-physical-stofstalen.webp",
    "previewAsset": "jd-branche-159-4.webp"
   }
  ],
  "productId": 159,
  "basePrice": 7.99,
  "editorRoute": "/pages/demo?view=maatadvies-studio",
  "cover": 2,
  "legacyOptions": [
   {
    "label": "Maatadvies met tabelregels",
    "url": "/pages/demo?view=maatadvies-studio",
    "price": 7.99,
    "id": 159
   }
  ],
  "imageAsset": "jd-branche-159-3.webp"
 },
 {
  "name": "Compatibiliteitscheck",
  "description": "Productcompatibiliteit opzoektabel.",
  "branch": "Branchebreed",
  "task": "Controleren",
  "goal": "Helpen kiezen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-160-3.webp",
  "options": [
   {
    "label": "Compatibiliteitscheck",
    "id": 160,
    "price": 7.99,
    "url": "/pages/demo?view=compatibiliteit-studio"
   }
  ],
  "presets": [
   {
    "label": "Verlichting",
    "id": 160,
    "slot": 0,
    "url": "/pages/demo?view=compatibiliteit-studio&ontwerp=1",
    "price": 7.99,
    "title": "Past deze lamp op jouw fitting?",
    "body": "Controleer de combinatie van aansluiting en uitvoering.",
    "photo": "jdb-lamp.jpg",
    "previewAsset": "jd-branche-160-1.webp"
   },
   {
    "label": "Tuinmaterialen",
    "id": 160,
    "slot": 1,
    "url": "/pages/demo?view=compatibiliteit-studio&ontwerp=2",
    "price": 7.99,
    "title": "Past deze aansluiting op je systeem?",
    "body": "Vergelijk de eigenschappen van je aansluiting.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-160-2.webp"
   },
   {
    "label": "Gereedschap",
    "id": 160,
    "slot": 2,
    "url": "/pages/demo?view=compatibiliteit-studio&ontwerp=3",
    "price": 7.99,
    "title": "Past dit accessoire op je machine?",
    "body": "Controleer de uitvoering en de gevraagde aansluiting.",
    "photo": "jd-physical-gereedschapskist.webp",
    "previewAsset": "jd-branche-160-3.webp"
   },
   {
    "label": "Montage",
    "id": 160,
    "slot": 3,
    "url": "/pages/demo?view=compatibiliteit-studio&ontwerp=4",
    "price": 7.99,
    "title": "Welke bevestiging past hierbij?",
    "body": "Vergelijk de gekozen onderdelen met de vereisten.",
    "photo": "jd-fence-material-bracket.webp",
    "previewAsset": "jd-branche-160-4.webp"
   }
  ],
  "productId": 160,
  "basePrice": 7.99,
  "editorRoute": "/pages/demo?view=compatibiliteit-studio",
  "cover": 2,
  "legacyOptions": [
   {
    "label": "Productcompatibiliteit opzoektabel",
    "url": "/pages/demo?view=compatibiliteit-studio",
    "price": 7.99,
    "id": 160
   }
  ],
  "imageAsset": "jd-branche-160-3.webp"
 },
 {
  "name": "Pakketsamensteller",
  "description": "Pakket in meerdere stappen.",
  "branch": "Branchebreed",
  "task": "Configureren",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-161-2.webp",
  "options": [
   {
    "label": "Pakketsamensteller",
    "id": 161,
    "price": 14.99,
    "url": "/pages/demo?view=pakketstappen-studio"
   }
  ],
  "presets": [
   {
    "label": "Wonen",
    "id": 161,
    "slot": 0,
    "url": "/pages/demo?view=pakketstappen-studio&ontwerp=1",
    "price": 14.99,
    "title": "Stel je interieurpakket samen",
    "body": "Kies je onderdelen en bekijk de samenstelling.",
    "photo": "jdq-interior.jpg",
    "previewAsset": "jd-branche-161-1.webp"
   },
   {
    "label": "Planten",
    "id": 161,
    "slot": 1,
    "url": "/pages/demo?view=pakketstappen-studio&ontwerp=2",
    "price": 14.99,
    "title": "Maak je plantpakket compleet",
    "body": "Kies per stap de benodigdheden voor je groene hoek.",
    "photo": "jd-physical-plant.webp",
    "previewAsset": "jd-branche-161-2.webp"
   },
   {
    "label": "Cadeaus",
    "id": 161,
    "slot": 2,
    "url": "/pages/demo?view=pakketstappen-studio&ontwerp=3",
    "price": 14.99,
    "title": "Maak je eigen geschenkpakket",
    "body": "Kies de inhoud en controleer het complete pakket.",
    "photo": "jd-approved-01-chocolade.webp",
    "previewAsset": "jd-branche-161-3.webp"
   },
   {
    "label": "Montage",
    "id": 161,
    "slot": 3,
    "url": "/pages/demo?view=pakketstappen-studio&ontwerp=4",
    "price": 14.99,
    "title": "Stel je montagepakket samen",
    "body": "Selecteer de benodigdheden voor je werkzaamheden.",
    "photo": "jd-physical-gereedschapskist.webp",
    "previewAsset": "jd-branche-161-4.webp"
   }
  ],
  "productId": 161,
  "basePrice": 14.99,
  "editorRoute": "/pages/demo?view=pakketstappen-studio",
  "cover": 1,
  "legacyOptions": [
   {
    "label": "Pakket in meerdere stappen",
    "url": "/pages/demo?view=pakketstappen-studio",
    "price": 14.99,
    "id": 161
   }
  ],
  "imageAsset": "jd-branche-161-2.webp"
 },
 {
  "name": "Meubelconfigurator",
  "description": "Keuken of meubelconfigurator.",
  "branch": "Branchebreed",
  "task": "Configureren",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-163-1.webp",
  "options": [
   {
    "label": "Meubelconfigurator",
    "id": 163,
    "price": 14.99,
    "url": "/pages/demo?view=tool-163-studio"
   }
  ],
  "presets": [
   {
    "label": "Maatkast",
    "id": 163,
    "slot": 0,
    "url": "/pages/demo?view=tool-163-studio&ontwerp=1",
    "price": 14.99,
    "title": "Ontwerp je kast op maat",
    "body": "Kies de uitvoering, afmeting en afwerking.",
    "photo": "jd-showcase-interior.jpg",
    "previewAsset": "jd-branche-163-1.webp"
   },
   {
    "label": "Buitenkeuken",
    "id": 163,
    "slot": 1,
    "url": "/pages/demo?view=tool-163-studio&ontwerp=2",
    "price": 14.99,
    "title": "Stel je buitenmeubel samen",
    "body": "Kies de maat en afwerking voor jouw buitenruimte.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-163-2.webp"
   },
   {
    "label": "Werktafel",
    "id": 163,
    "slot": 2,
    "url": "/pages/demo?view=tool-163-studio&ontwerp=3",
    "price": 14.99,
    "title": "Maak je werktafel passend",
    "body": "Stel de uitvoering af op je beschikbare werkruimte.",
    "photo": "jdb-table.jpg",
    "previewAsset": "jd-branche-163-3.webp"
   },
   {
    "label": "Keukenwand",
    "id": 163,
    "slot": 3,
    "url": "/pages/demo?view=tool-163-studio&ontwerp=4",
    "price": 14.99,
    "title": "Configureer je meubelwand",
    "body": "Kies de onderdelen en bekijk de materiaalkeuze.",
    "photo": "jd-showcase-living.jpg",
    "previewAsset": "jd-branche-163-4.webp"
   }
  ],
  "productId": 163,
  "basePrice": 14.99,
  "editorRoute": "/pages/demo?view=tool-163-studio",
  "cover": 0,
  "legacyOptions": [
   {
    "label": "Keuken of meubelconfigurator",
    "url": "/pages/demo?view=tool-163-studio",
    "price": 14.99,
    "id": 163
   }
  ],
  "imageAsset": "jd-branche-163-1.webp"
 },
 {
  "name": "Productpersonalisatie",
  "description": "Live bedrukking of gravure.",
  "branch": "Branchebreed",
  "task": "Configureren",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-164-1.webp",
  "options": [
   {
    "label": "Productpersonalisatie",
    "id": 164,
    "price": 14.99,
    "url": "/pages/demo?view=tool-164-studio"
   }
  ],
  "presets": [
   {
    "label": "Wedstrijdshirt",
    "id": 164,
    "slot": 0,
    "url": "/pages/demo?view=tool-164-studio&ontwerp=1",
    "price": 14.99,
    "title": "Jouw naam op het wedstrijdshirt",
    "body": "Voeg je naam en rugnummer toe en bepaal de plaatsing.",
    "photo": "jdp-group.jpg",
    "previewAsset": "jd-branche-164-1.webp"
   },
   {
    "label": "Cadeaumok",
    "id": 164,
    "slot": 1,
    "url": "/pages/demo?view=tool-164-studio&ontwerp=2",
    "price": 14.99,
    "title": "Maak een mok met jouw boodschap",
    "body": "Kies je eigen tekst en plaats die op de mok.",
    "photo": "jd-approved-14-espresso.webp",
    "previewAsset": "jd-branche-164-2.webp"
   },
   {
    "label": "Hanger",
    "id": 164,
    "slot": 2,
    "url": "/pages/demo?view=tool-164-studio&ontwerp=3",
    "price": 14.99,
    "title": "Ontwerp jouw persoonlijke gravure",
    "body": "Plaats een korte naam of boodschap op de hanger.",
    "photo": "jd-approved-09-roos.webp",
    "previewAsset": "jd-branche-164-3.webp"
   },
   {
    "label": "Geschenkdoos",
    "id": 164,
    "slot": 3,
    "url": "/pages/demo?view=tool-164-studio&ontwerp=4",
    "price": 14.99,
    "title": "Geef je verpakking een persoonlijk detail",
    "body": "Voeg tekst of een eigen beeld toe aan het deksel.",
    "photo": "jd-approved-01-chocolade.webp",
    "previewAsset": "jd-branche-164-4.webp"
   }
  ],
  "productId": 164,
  "basePrice": 14.99,
  "editorRoute": "/pages/demo?view=tool-164-studio",
  "cover": 0,
  "legacyOptions": [
   {
    "label": "Live bedrukking of gravure",
    "url": "/pages/demo?view=tool-164-studio",
    "price": 14.99,
    "id": 164
   }
  ],
  "imageAsset": "jd-branche-164-1.webp"
 },
 {
  "name": "Materialenplanner",
  "description": "Project en materialenplanner.",
  "branch": "Branchebreed",
  "task": "Plannen",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-166-3.webp",
  "options": [
   {
    "label": "Materialenplanner",
    "id": 166,
    "price": 14.99,
    "url": "/pages/demo?view=materialenplan-studio"
   }
  ],
  "presets": [
   {
    "label": "Verbouwing",
    "id": 166,
    "slot": 0,
    "url": "/pages/demo?view=materialenplan-studio&ontwerp=1",
    "price": 14.99,
    "title": "Welke materialen vraagt je verbouwing?",
    "body": "Maak een lijst met materiaal, hoeveelheid en eenheid.",
    "photo": "jd-showcase-interior.jpg",
    "previewAsset": "jd-branche-166-1.webp"
   },
   {
    "label": "Terras",
    "id": 166,
    "slot": 1,
    "url": "/pages/demo?view=materialenplan-studio&ontwerp=2",
    "price": 14.99,
    "title": "Plan de materialen voor je terras",
    "body": "Leg de aantallen en uitvoeringen voor je terras vast.",
    "photo": "jdq-garden.jpg",
    "previewAsset": "jd-branche-166-2.webp"
   },
   {
    "label": "Stoffenatelier",
    "id": 166,
    "slot": 2,
    "url": "/pages/demo?view=materialenplan-studio&ontwerp=3",
    "price": 14.99,
    "title": "Bereken je materiaalstaat",
    "body": "Maak een overzicht van stoffen en benodigdheden.",
    "photo": "jd-physical-stofstalen.webp",
    "previewAsset": "jd-branche-166-3.webp"
   },
   {
    "label": "Montage",
    "id": 166,
    "slot": 3,
    "url": "/pages/demo?view=materialenplan-studio&ontwerp=4",
    "price": 14.99,
    "title": "Maak je materiaalstaat voor de klus",
    "body": "Vul de benodigde onderdelen en hoeveelheden in.",
    "photo": "jd-physical-gereedschapskist.webp",
    "previewAsset": "jd-branche-166-4.webp"
   }
  ],
  "productId": 166,
  "basePrice": 14.99,
  "editorRoute": "/pages/demo?view=materialenplan-studio",
  "cover": 2,
  "legacyOptions": [
   {
    "label": "Project en materialenplanner",
    "url": "/pages/demo?view=materialenplan-studio",
    "price": 14.99,
    "id": 166
   }
  ],
  "imageAsset": "jd-branche-166-3.webp"
 },
 {
  "name": "Bestelmatrix",
  "description": "Bestelmatrix voor varianten.",
  "branch": "Branchebreed",
  "task": "Bestellen",
  "goal": "Meer verkopen",
  "image": "https://jordigi.nl/cdn/shop/t/18/assets/jd-branche-244-4.webp",
  "options": [
   {
    "label": "Bestelmatrix",
    "id": 244,
    "price": 9.99,
    "url": "/pages/demo?view=bestelmatrix-studio"
   }
  ],
  "presets": [
   {
    "label": "Meubelcollectie",
    "id": 244,
    "slot": 0,
    "url": "/pages/demo?view=bestelmatrix-studio&ontwerp=1",
    "price": 9.99,
    "title": "Bestel je meubeluitvoeringen",
    "body": "Vul per uitvoering het gewenste aantal in.",
    "photo": "jdb-sofa.jpg",
    "previewAsset": "jd-branche-244-1.webp"
   },
   {
    "label": "Kwekerij",
    "id": 244,
    "slot": 1,
    "url": "/pages/demo?view=bestelmatrix-studio&ontwerp=2",
    "price": 9.99,
    "title": "Bestel per potmaat",
    "body": "Verdeel je aantallen over de maten van de collectie.",
    "photo": "jd-physical-plant.webp",
    "previewAsset": "jd-branche-244-2.webp"
   },
   {
    "label": "Textielcollectie",
    "id": 244,
    "slot": 2,
    "url": "/pages/demo?view=bestelmatrix-studio&ontwerp=3",
    "price": 9.99,
    "title": "Plan je bestelling per serie",
    "body": "Vul per uitvoering de gewenste aantallen in.",
    "photo": "jd-physical-stofstalen.webp",
    "previewAsset": "jd-branche-244-3.webp"
   },
   {
    "label": "Magazijn",
    "id": 244,
    "slot": 3,
    "url": "/pages/demo?view=bestelmatrix-studio&ontwerp=4",
    "price": 9.99,
    "title": "Maak je bestellijst compleet",
    "body": "Leg de aantallen per uitvoering in één overzicht vast.",
    "photo": "jd-approved-15-heftruck.webp",
    "previewAsset": "jd-branche-244-4.webp"
   }
  ],
  "productId": 244,
  "basePrice": 9.99,
  "editorRoute": "/pages/demo?view=bestelmatrix-studio",
  "cover": 3,
  "legacyOptions": [
   {
    "label": "Bestelmatrix voor varianten",
    "url": "/pages/demo?view=bestelmatrix-studio",
    "price": 9.99,
    "id": 244
   }
  ],
  "imageAsset": "jd-branche-244-4.webp"
 }
];
for(const tool of window.JordigiToolCatalog)tool.image=new URL(tool.imageAsset,document.currentScript.src).href;
